<template>
  <router-view v-slot="{ Component }">
    <transition
      appear
      appear-active-class="animate__animated animate__fadeIn"
      enter-active-class="animate__animated animate__fadeIn"
    >
      <component :is="Component" />
    </transition>
  </router-view>
</template>
